import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-not-found-view" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-between align-items-center\"></div><div class=\"dt-container\"><div class=\"d-flex justify-content-center\"><h1>Ahh, nuts!</h1></div><div class=\"d-flex justify-content-center\"><h2>The page you&#39;re looking for can&#39;t be found.</h2></div><div class=\"d-flex justify-content-center\">Sorry for the inconvenience!</div></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}